﻿import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static get values() {
        return {
            searchUrl: String,
            searchResultUrl: String,
            upVoteUrl: String,
            downVoteUrl: String,
            thanksForTheFeedbackMessage: String
        };
    }

    static get targets() {
        return ["search", "searchResultSection", "searchResult"];
    }

    async dispatchChatWithUsRequestedEvent() {
        this.dispatch("chatWithUsRequested", { bubbles: true });
    }

    searchTargetConnected(target) {
        jQuery(target)
            .typeahead(
                {
                    minLength: 3
                },
                {
                    source: async (query, _, asyncResults) => {
                        const response = await fetch(`${this.searchUrlValue}?${new URLSearchParams([["term", query]])}`);
                        const json = await response.json();
                        asyncResults(json);
                    },
                    valueKey: "id",
                    displayKey: "question"
                }
            )
            .on("typeahead:autocompleted typeahead:selected", async (_, { id }) => {
                const response = await fetch(`${this.searchResultUrlValue}?${new URLSearchParams([["faqItemId", id]])}`);

                if (response.ok) {
                    this.searchResultSectionTarget.classList.remove("d-none");
                    this.searchResultTarget.innerHTML = await response.text();
                    this.searchResultTarget.querySelector(".accordion-body").classList.add("show");
                }
            });
    }

    async upVote({ currentTarget, params: { faqItemId } }) {
        if ((await fetch(`${this.upVoteUrlValue}?faqItemId=${faqItemId}`, { method: "post" })).ok) {
            currentTarget.parentNode.textContent = this.thanksForTheFeedbackMessageValue;
        }
    }

    async downVote({ currentTarget, params: { faqItemId } }) {
        if ((await fetch(`${this.downVoteUrlValue}?faqItemId=${faqItemId}`, { method: "post" })).ok) {
            currentTarget.parentNode.textContent = this.thanksForTheFeedbackMessageValue;
        }
    }
}
